import { call, put, takeLatest } from "redux-saga/effects";

import 
{ 
    GET_ALL_UNREAD_NOTIFICATIONS_LOADING
} from "./actionTypes";

import {
    getAllUnreadNotificationData,
    getAllUnreadNotificationFailed
} from "./actions";

import 
{
    getAllUnreadNotificationDataAPI
} from "./helper";


function* getAllUnreadNotificationDataSaga() {
    try {
        const response = yield call(getAllUnreadNotificationDataAPI);
        yield put(getAllUnreadNotificationData(response));
    } catch (error) {
        yield put(getAllUnreadNotificationFailed(error));
    }
}


export default function* rootSaga() {
    yield takeLatest(GET_ALL_UNREAD_NOTIFICATIONS_LOADING, getAllUnreadNotificationDataSaga);
}